/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Link } from '../../models/link';
import { UpdateLinkDto } from '../../models/update-link-dto';

export interface LinksControllerUpdate$Params {
  id: string;
      body: UpdateLinkDto
}

export function linksControllerUpdate(http: HttpClient, rootUrl: string, params: LinksControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<Link>> {
  const rb = new RequestBuilder(rootUrl, linksControllerUpdate.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Link>;
    })
  );
}

linksControllerUpdate.PATH = '/links/{id}';
